import React from 'react';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import {
  FDIcon,
  FDStat,
} from '@facet-wealth/design';
import AccountCard from 'Components/ComponentLibrary/Organisms/Account/AccountCard';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 4),
  },
  paper: {
    backgroundColor: theme.palette.facet.lightGray,
    padding: theme.spacing(4),
    width: '100%',
    borderRadius: theme.radius.md,
    display: 'grid',
    gap: `${theme.spacing(2)}px`,
    gridTemplateColumns: 'repeat(2, 50%)',
  },
}));

const metaOverrideSet = fr.metaOverride()
  .nameOverride(['amount', 'transferDate', 'transferSourceMaskedAccountNumber', 'status'], {
    _component: () => FDStat,
  }, {
    ordinal: 200,
  });

const Content = () => {
  const classes = useStyles();
  const { pageContentResource: resource } = usePageContentContext();

  return (
    <PageContentContainer maxWidth={'xs'}>
      <PageContentTop
        badgeImage={resource.attr('imageUrl')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <FDIcon
        color="success"
        icon="checkCircleIcon"
        size="xl"
        alignSelf={'center'}
      />
      <AccountCard
        image={resource.relationship(fr.relationships.facetIcon.name)?.link('related').url()}
        title={resource.attr('transferDestinationAccountName')}
        subtitle={resource.attr('transferDestinationMaskedAccountNumber')}
      />

      <Text color={'black'} text="Transaction Details" variant="h6" weight="bold" />
      <Paper className={classes.paper}>
        <MetaControl
          resource={resource}
          attrName={'amount'}
          metaOverrideSet={metaOverrideSet}
        />
        <MetaControl
          resource={resource}
          attrName={'transferDate'}
          metaOverrideSet={metaOverrideSet}
        />
        <MetaControl
          resource={resource}
          attrName={'transferSourceMaskedAccountNumber'}
          metaOverrideSet={metaOverrideSet}
        />
        <MetaControl
          resource={resource}
          attrName={'status'}
          metaOverrideSet={metaOverrideSet}
        />
      </Paper>
    </PageContentContainer>
  );
};

export default Content;
